export const gtmNoSearchResultsEvent = (query: string) => ({
  event: 'op_web_zero_search_reulsts',
  query,
});

export default gtmNoSearchResultsEvent;
